import * as React from "react";
import { Arrow } from "sb-resp-ui";
// TODO: Refactor - Use `defaultValue` or `value` instead of `selected` on <option>
export class Dropdown extends React.Component {
    constructor(props) {
        super(props);
        this.toggleExpandCollapse = (e) => {
            this.setState(prevstate => ({ isExpanded: !prevstate.isExpanded }));
            e.stopPropagation();
        };
        this.state = { isExpanded: false };
    }
    renderItems() {
        return {
            desktop: this.props.data.map(this.renderItemDesktop, this),
            mobile: this.props.data.map(this.renderItemMobile, this)
        };
    }
    renderItemDesktop(item) {
        return (React.createElement("div", { key: item.id, onClick: () => { this.props.selectItem(item.id); }, "data-id": item.id, className: "rj-dropdown__item", "data-selected": item.isSelected }, item.text));
    }
    renderItemMobile(item) {
        return (React.createElement("option", { key: item.id, value: item.id }, item.text));
    }
    render() {
        const { blockName, defaultText, data } = this.props;
        const selected = data.find(x => x.isSelected);
        const label = selected ? selected.text : defaultText;
        const value = selected ? selected.id : "";
        return (React.createElement("div", { className: `rj-dropdown rj-${blockName}__dropdown`, onClick: (e) => { this.toggleExpandCollapse(e); } },
            React.createElement("span", { className: "rj-dropdown__active-item" }, label),
            React.createElement(Arrow, { direction: "down" }),
            React.createElement("div", { className: "rj-dropdown__html" }, this.state.isExpanded && this.renderItems().desktop),
            React.createElement("select", { value: value, onChange: (e) => { this.props.selectItem(e.target.value); }, className: "rj-dropdown__native" }, this.renderItems().mobile)));
    }
}
//# sourceMappingURL=Dropdown.js.map